import React, { useState, useEffect } from "react";

import Form from "react-bootstrap/Form";

const Header = (props) => {

    const [title, setTitle] = useState("Find A Business Expert")
    const [titleMargin, setTitleMargin] = useState("40")
    const [subtitle, setSubtitle] = useState("Subtitle")

   useEffect(() => {
    // Omit the subtitle block entirely when empty so it doesn't leave a gap under the title
    const subtitleBlock = subtitle.trim() ? `
                                      <table border="0" cellpadding="0" cellspacing="0" class="heading_block block-3 mobile_hide" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
                                          <tr>
                                              <td class="pad mobile_hide" style="width:100%;text-align:center;padding-top:2px;">
                                                  <h2 class="mobile_hide" style="margin: 0; color: #555555; font-size: 16px; font-family: Myriad Pro, Arial, Helvetica Neue, Helvetica, sans-serif; line-height: 1.2; text-align: center; direction: ltr; font-weight: 700; letter-spacing: normal; margin-top: 0; margin-bottom: 0;"><span class="tinyMce-placeholder">${subtitle}</span></h2>
                                              </td>
                                          </tr>
                                      </table>` : ""

    props.updateComponentHTML(props.id,
      `
      <table align="center" border="0" cellpadding="0" cellspacing="0" class="row row-2 header-row" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
          <tbody>
              <tr>
                  <td>
                      <table align="center" border="0" cellpadding="0" cellspacing="0" class="row-content" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; color: #000000; border-radius: 0; width: 600px;" width="600">
                          <tbody>
                              <tr>
                                  <td class="column column-1" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;" width="22%">
                                      <table border="0" cellpadding="0" cellspacing="0" class="image_block block-2" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
                                          <tr>
                                              <td class="pad" style="width:100%;padding-right:0px;padding-left:0px;">
                                                  <div align="left" class="alignment" style="line-height:10px"><img src="https://awsuk01.fivecrm.com/603317/user_files/uploads/999/images/emailheader.jpg" style="display: block; height: auto; border: 0; width: 138px; max-width: 100%;" width="138"/></div>
                                              </td>
                                          </tr>
                                      </table>
                                  </td>
                                  <td class="column column-2" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;" width="78%">
                                      <table border="0" cellpadding="0" cellspacing="0" class="heading_block block-2" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
                                          <tr>
                                              <td class="pad" style="width:100%;text-align:center;padding-top:${titleMargin}px;">
                                                  <h1 style="margin: 0; color: #000000; font-size: 36px; font-family: Myriad Pro, Arial, Helvetica Neue, Helvetica, sans-serif; line-height: 1.2; text-align: center; direction: ltr; font-weight: 700; letter-spacing: normal; margin-top: 0; margin-bottom: 0;"><span class="tinyMce-placeholder">${title}</span></h1>
                                              </td>
                                          </tr>
                                      </table>${subtitleBlock}
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </td>
              </tr>
          </tbody>
      </table>
      `)
 }, [title, titleMargin, subtitle])

   return (
    <>
    <Form.Group controlId="exampleForm.ControlSelect1">
       <Form.Label>Change Title</Form.Label>
       <Form.Control onChange={(event) => setTitle(event.target.value)} value={title} />
       <Form.Label>Margin</Form.Label>
       <Form.Control onChange={(event) => setTitleMargin(event.target.value)} value={titleMargin} />
       <Form.Label>Change Subtitle</Form.Label>
       <Form.Control onChange={(event) => setSubtitle(event.target.value)} value={subtitle} />

    </Form.Group>
    </>
   )
}

export default Header;
